import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useVertical } from '../context/VerticalContext';

export interface OrgSettings {
    vat_registered: boolean;
    vat_registration_number?: string;
    vat_registered_from?: string;
    currency: string;
    default_labor_rate?: number;
    default_parts_markup?: number;
}

export const useOrgSettings = () => {
    const { activeOrgId } = useVertical();
    const [settings, setSettings] = useState<OrgSettings>({
        vat_registered: false,
        currency: 'GBP'
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!activeOrgId) return;

        const fetchSettings = async () => {
            try {
                const { data: orgData, error: orgError } = await supabase
                    .from('organizations')
                    .select('branding, settings')
                    .eq('id', activeOrgId)
                    .single();

                if (orgError) throw orgError;

                // Read all VAT + fiscal settings from organizations.settings (single source of truth)
                const s = orgData?.settings || {};
                const b = orgData?.branding?.fiscal || {};

                setSettings({
                    vat_registered: s.is_vat_registered ?? b.is_vat_registered ?? false,
                    vat_registration_number: s.vat_registration_number ?? b.vat_registration_number,
                    vat_registered_from: s.vat_registered_from ?? undefined,
                    currency: 'GBP',
                    default_labor_rate: s.default_labor_rate || 0,
                    default_parts_markup: s.default_parts_markup || 0
                });
            } catch (err) {
                console.error('Error fetching org settings:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchSettings();
    }, [activeOrgId]);

    return { settings, loading };
};
